import { render } from "./Invoice.vue?vue&type=template&id=1c6943b6&scoped=true&ts=true"
import script from "./Invoice.vue?vue&type=script&lang=ts"
export * from "./Invoice.vue?vue&type=script&lang=ts"

import "./Invoice.vue?vue&type=style&index=0&id=1c6943b6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6943b6"]])

export default __exports__